import React from 'react';
import { Center, VStack, Spinner, Box, Text } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import CircularLogo from './CircularLogo';

// Golden pulsing animation
const pulseGlow = keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(236, 189, 0, 0.7);
  }
  70% {
    transform: scale(1.02);
    box-shadow: 0 0 0 25px rgba(236, 189, 0, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(236, 189, 0, 0);
  }
`;

const LoadingScreen = ({ height = '60vh', size = 120, label = '' }) => {
  const darkRed = '#620404';
  const gold = '#ecbd00';

  return (
    <Center h={height} w="100%" px={4}>
      <VStack spacing={8} align="center">
        {/* Pulsing Container for Logo */}
        <Box
          borderRadius="full"
          animation={`${pulseGlow} 2.5s infinite ease-in-out`}
          display="flex"
          alignItems="center"
          justifyContent="center"
          p={1}
          bg="white"
        >
          <CircularLogo size={size} />
        </Box>

        {/* Custom Ornate Spinner and Optional Label */}
        <VStack spacing={4} align="center">
          <Spinner
            thickness="4px"
            speed="0.8s"
            emptyColor="gray.100"
            color={gold}
            size="xl"
          />
          {label && (
            <Text
              color={darkRed}
              fontSize="lg"
              fontWeight="700"
              fontFamily="'Poppins', sans-serif"
              textAlign="center"
              letterSpacing="wide"
            >
              {label}
            </Text>
          )}
        </VStack>
      </VStack>
    </Center>
  );
};

export default LoadingScreen;
